import {Hide} from 'platform/foundation';
import {css} from 'styled-components';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {AdaptiveImageDc} from '../../AdaptiveImageDc/AdaptiveImageDc';

export interface LightboxItemProps extends TestIdProps {
  imageUrl: string | Nullish;
  isActive: boolean;
  title?: string;
  onClick: () => void;
}

export function Slide(props: LightboxItemProps) {
  return (
    <Hide when={!props.isActive}>
      <div
        css={css`
          width: 100%;
          height: 100%;
          max-width: 100%;
          max-height: 100%;
          position: ${props.isActive ? 'relative' : 'absolute'};
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        `}
        onClick={props.onClick}
      >
        <AdaptiveImageDc
          url={props.imageUrl ?? undefined}
          alt={props.title}
          position="center"
          fit="cover"
          isLazy
          hasSpinner
          data-testid={suffixTestId('slideImage', props)}
        />
      </div>
    </Hide>
  );
}
